export default function TopListIcon({}) {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.5488 4.09277C11.7191 3.73833 12.2038 3.71607 12.4131 4.02637L12.4512 4.09277L14.3525 8.05078C14.5439 8.4491 14.8991 8.74007 15.3203 8.85156L15.5039 8.8877L19.8564 9.47363C20.2462 9.52605 20.417 9.97944 20.1865 10.2744L20.1348 10.3311L16.958 13.3623C16.6384 13.6674 16.472 14.0953 16.4961 14.5303L16.5186 14.7168L17.3066 19.0371C17.3768 19.4238 16.9981 19.7257 16.6465 19.5977L16.5771 19.5664L12.7119 17.4824C12.3232 17.2727 11.8651 17.2462 11.459 17.4033L11.2881 17.4824L7.42285 19.5664C7.07701 19.7529 6.67308 19.4869 6.68555 19.1133L6.69336 19.0371L7.48145 14.7168C7.56078 14.282 7.44429 13.8378 7.16895 13.5L7.04199 13.3623L3.86523 10.3311C3.5809 10.0597 3.70896 9.59276 4.06836 9.48926L4.14355 9.47363L8.49609 8.8877C8.93373 8.82868 9.31954 8.58069 9.55566 8.21484L9.64746 8.05078L11.5488 4.09277Z"
          stroke="white"
        />
      </svg>
    </>
  );
}
